<template>
  <img
    src="@/assets/logo.png"
    draggable="false"
    @contextmenu.prevent
    @dragstart.prevent
    :style="{ width: width }"
    :class="{ 'logo-photonow': !customCSS }"
  />
</template>

<script>
export default {
  props: {
    customCSS: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: String,
      required: false,
      default: "250px",
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-photonow {
  /* width: 28%; */
  margin: 0 auto;
  padding: 15px 0px;
  image-rendering: optimizeQuality;
  text-rendering: optimizeLegibility;
}
</style>
